module.exports = __webpack_public_path__ + "media/use_cases/slider-logo-3-06e34bb5.png";